import { WordCloudMapper } from '../mapper/WordCloudMapper';

export const wordCloudMapper = new WordCloudMapper();
